import React, { useState } from 'react';
import { KeyRound, Smartphone } from 'lucide-react';
import { DmpLogo } from '../../brand/DmpLogo';
import { OwnerButton } from '../OwnerShell';
import { TextField } from '../OwnerFields';
import { fromBn } from '../../../utils/bn';
import type { OwnerNav } from '../../../types/owner';
type Mode = 'password' | 'otp' | 'forgot';
export function OwnerLogin({
  nav
}: {
  nav: OwnerNav;
}) {
  const [mode, setMode] = useState<Mode>('password');
  const [mobile, setMobile] = useState('০১৭১২৩৪৫৬৭৮');
  const [pass, setPass] = useState('Rahim@2026');
  const [error, setError] = useState('');
  const validMobile = /^01[3-9]\d{8}$/.test(fromBn(mobile).replace(/\D/g, ''));
  const login = () => {
    if (!validMobile) return setError('সঠিক মোবাইল নম্বর দিন');
    if (mode === 'password') {
      if (pass.length < 8) return setError('পাসওয়ার্ড সঠিক নয়');
      nav.showToast('স্বাগতম, মোঃ রহিম উদ্দিন');
      nav.reset('home');
      return;
    }
    nav.setOtpPurpose(mode === 'otp' ? 'login' : 'reset');
    nav.go('otp');
  };
  return <div className="no-scrollbar flex h-full flex-col overflow-y-auto bg-white" data-id="element-1672" data-mp="3oxu8ntw1vxyz">
      <div className="bg-navy-800 px-6 pb-10 pt-6 text-center text-white" data-id="element-1673" data-mp="3tuueq4swh0q3">
        <DmpLogo size={72} className="mx-auto" data-id="element-1674" data-mp="1q0c09j2ttld" />
        <p className="mt-3 font-heading text-lg font-bold" data-id="element-1675" data-mp="6pv1c8n7eb4b">ডিএমপি গাড়ির মালিক সেবা</p>
        <p className="text-xs text-navy-200" data-id="element-1676" data-mp="6niaf5zgwqf4">যানবাহন নিবন্ধন, তথ্য যাচাই ও ডিজিটাল সেবা</p>
      </div>
      <div className="-mt-6 flex-1 rounded-t-3xl bg-white px-5 pt-6" data-id="element-1677" data-mp="bn4yybkqxt38">
        <h1 className="font-heading text-xl font-bold text-navy-900" data-id="element-1678" data-mp="gmhmyznct67e">{mode === 'forgot' ? 'পাসওয়ার্ড ভুলে গেছেন?' : 'লগইন'}</h1>
        {mode !== 'forgot' && <div className="mt-3 grid grid-cols-2 rounded-lg bg-slate-100 p-1" role="tablist" data-id="element-1679" data-mp="pgw1h0028cpg">
            {(['password', 'otp'] as const).map(m => <button key={m} role="tab" aria-selected={mode === m} onClick={() => {
          setMode(m);
          setError('');
        }} className={`flex items-center justify-center gap-1.5 rounded-md py-2 text-sm font-semibold ${mode === m ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500'}`} data-id="element-1680" data-mp="udcn9njseezd">
                {m === 'password' ? <KeyRound className="h-4 w-4" data-id="element-1681" data-mp="2qgirexrwpv3d" /> : <Smartphone className="h-4 w-4" data-id="element-1682" data-mp="35787adgbbydk" />}
                {m === 'password' ? 'পাসওয়ার্ড' : 'OTP দিয়ে লগইন'}
              </button>)}
          </div>}
        {mode === 'forgot' && <p className="mt-1 text-sm text-slate-500" data-id="element-1683" data-mp="3e7n3i7utexvu">নিবন্ধিত মোবাইল নম্বরে OTP পাঠিয়ে নতুন পাসওয়ার্ড নির্ধারণ করুন।</p>}
        <div className="mt-4 space-y-3.5" data-id="element-1684" data-mp="3a5jf6in1ryt5">
          <TextField id="l-mob" label="মোবাইল নম্বর" value={mobile} onChange={v => {
          setMobile(v);
          setError('');
        }} inputMode="tel" error={!validMobile && error ? error : undefined} data-id="element-1685" data-mp="3a8nt47qbe8x0" />
          {mode === 'password' && <TextField id="l-pass" label="পাসওয়ার্ড" type="password" value={pass} onChange={v => {
          setPass(v);
          setError('');
        }} error={validMobile ? error || undefined : undefined} data-id="element-1686" data-mp="3j5g50nl6b3ps" />}
        </div>
        {mode === 'password' && <button onClick={() => {
        setMode('forgot');
        setError('');
      }} className="mt-2 text-sm font-medium text-navy-700" data-id="element-1687" data-mp="4axq5ffj8sr9">পাসওয়ার্ড ভুলে গেছেন?</button>}
        <OwnerButton className="mt-5" onClick={login} data-id="element-1688" data-mp="9c4wda211jvt">{mode === 'password' ? 'লগইন করুন' : 'OTP পাঠান'}</OwnerButton>
        {mode === 'forgot' ? <OwnerButton variant="ghost" className="mt-2" onClick={() => setMode('password')} data-id="element-1689" data-mp="3votrdwvdpf0b">লগইনে ফিরে যান</OwnerButton> : <OwnerButton variant="outline" className="mt-3" onClick={() => nav.reset('register')} data-id="element-1690" data-mp="3hs6qxk47w6pn">নতুন অ্যাকাউন্ট তৈরি করুন</OwnerButton>}
        <p className="mt-6 pb-6 text-center text-[11px] text-slate-400" data-id="element-1691" data-mp="37sfyrp34q3sq">হেল্পলাইন: ০১৩২০-০৪২১১০ • ট্রাফিক বিভাগ, ডিএমপি</p>
      </div>
    </div>;
}